var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpvoteSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.00388 9.44347L2.0602 9.44347C0.918057 9.44347 -0.000370945 10.3625 -0.000371045 11.5055L-0.00037223 25.0557C-0.000372328 26.1868 0.918055 27.1177 2.0602 27.1177L5.00388 27.1177C6.14603 27.1177 7.06445 26.1868 7.06445 25.0557L7.06445 11.5055C7.06445 10.3625 6.14603 9.44347 5.00388 9.44347Z",
    fill: "#52ACBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7153 10.3275L19.1576 10.3275C19.1576 10.3275 20.0407 8.56011 20.0407 5.61442C20.0407 2.07957 17.3914 0.901294 16.2139 0.901294C15.0364 0.901293 14.4477 1.49043 14.4477 4.43613C14.4477 7.38183 11.7395 9.49096 9.99687 10.6457L9.99687 25.2446C11.8808 26.1165 15.6605 27.4126 21.5125 27.4126L23.3965 27.4126C25.6926 27.4126 27.6472 25.763 28.0357 23.5007L29.3545 15.8419C29.849 12.9551 27.6354 10.3275 24.7153 10.3275Z",
    fill: "#52ACBC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpvoteSuccess);
export default __webpack_public_path__ + "static/media/upvote-success.31d556ae4a7e2f9f41fea8c2b5c01963.svg";
export { ForwardRef as ReactComponent };